export default {
  title: {
    id: 'merchant-integrations-from-title',
    defaultMessage: 'Add a new integration',
  },
  getStarted: {
    id: 'merchant_integration_get_started_text',
    defaultMessage:
      'To get started, please choose the integration type you want to connect',
  },
  selectIntegrator: {
    id: 'merchant_integration_select_integrator',
    defaultMessage: 'Select integrator',
  },
  validate: {
    id: 'merchant_integration_validate',
    defaultMessage: 'Validate',
  },
  integrationCreatedTitle: {
    id: 'merchant_integration_created_title',
    defaultMessage: 'Your integration with {integrator} has been created!',
  },
  collectTokenTitle: {
    id: 'merchant_integration_collect_token_title',
    defaultMessage: 'Collect your token below and integrate it in {integrator}',
  },
  tokenInfoBlockTitle: {
    id: 'merchant_integration_token_info_block_title',
    defaultMessage: 'Next steps',
  },
  tokenInfoBlockContent: {
    id: 'merchant_integration_token_info_block_content',
    defaultMessage: 'Use this token to finalise your integration with our APIs',
  },
  done: {
    id: 'merchant_integration_done',
    defaultMessage: 'Done',
  },
}
